export default __webpack_public_path__ + "assets/img/Delete_Form_Vec.e013037f.svg";